import { render } from "./CalendarDetails.vue?vue&type=template&id=6928233b&scoped=true"
import script from "./CalendarDetails.vue?vue&type=script&lang=js"
export * from "./CalendarDetails.vue?vue&type=script&lang=js"

import "./CalendarDetails.vue?vue&type=style&index=0&id=6928233b&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6928233b"]])

export default __exports__